import { Injectable } from '@angular/core'
import { fromEvent, merge, of, Subscription, BehaviorSubject, map } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  networkStatus$!: Subscription
  isOnlineSubj$ = new BehaviorSubject<boolean>(true)
  isOnline$ = this.isOnlineSubj$.asObservable()

  checkNetworkStatus() {
    this.networkStatus$ = merge(
      of(null),
      fromEvent(window, 'online'),
      fromEvent(window, 'offline')
    )
      .pipe(map(() => navigator.onLine))
      .subscribe(status => {
        this.isOnlineSubj$.next(status)

        if (!status) {
          alert('Internet disconnected')
        }
      })
  }
}